import { gql } from '@apollo/client';

export const updateAccountGql = gql`
  mutation updateAccount($input: UpdateAccountDto!) {
    updateAccount(input: $input) {
      firstName
      lastName
      email
      username
      avatar
    }
  }
`;
